import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {persistStore, persistReducer, createTransform} from 'redux-persist';
import {rootReducer} from './reducers/rootReducer';
import storage from 'redux-persist/lib/storage';

const initialState = {};

const middleware = [thunk];

// navigationDisable must never survive a reload: a stale `true` restored from
// storage leaves the side navigation unclickable.
const resetNavigationDisable = createTransform(
  (inboundState) => ({...inboundState, navigationDisable: false}),
  (outboundState) => ({...outboundState, navigationDisable: false}),
  {whitelist: ['courseState']},
);

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['setNotificationErrorState'],
  transforms: [resetNavigationDisable],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, initialState, applyMiddleware(...middleware));
export const persistor = persistStore(store);
export default {store, persistor};
